import Joi from "joi";
import React from "react";
import { Link } from "react-router-dom";
import Form from "../../common/form.jsx";
import { IoMdTrash } from "react-icons/io";
import {
  Panel,
  PanelBody,
  PanelHeader,
} from "../../components/panel/panel.jsx";
import auth from "../../services/authservice";
import { getERinstruction, saveERinstruction } from "./../../services/erinstructions";
import { getCompanys } from "./../../services/companies";
import withRouter from "../../common/withRouter.jsx";
import { toast } from "react-toastify";
import { connect } from 'react-redux';
import { getCurrentUser, loadCurrentUser } from '../../store/users';
import Editor from "../../components/common/Editor"
import { serviceTypes } from "../../components/serviceType.jsx";
import { rootCauseTypes } from "../../components/rootCauseType.jsx";
import Select from "react-select";

const OptionWithAvatar = ({ innerProps, label, data }) => (
  <div {...innerProps} style={{ marginBottom: 5 }}>

    {data.icon && (
      <img
        src={data.icon}
        alt="Icon"
        style={{
          marginRight: "8px",
          borderRadius: "50%",
          width: "24px",
          height: "24px",
        }}
      />
    )}
    {label}
  </div>
);

const SingleValueWithAvatar = ({ innerProps, children, data }) => (
  <div {...innerProps} style={{ marginBottom: 5 }}>
    {data.icon && (
      <img
        src={data.icon}
        alt="Icon"
        style={{
          marginRight: "8px",
          borderRadius: "50%",
          width: "24px",
          height: "24px",

        }}
      />
    )}
    {children}
  </div>
);
class ERInstruction extends Form {
  constructor(props) {
    super(props);

    this.state = {
      data: {
        user: auth.getProfile()._id,
        businessNo: "",
        category: "",
        fieldType: "",
        description: "",
        name: "",
        serviceType: "",
        version: "",
        tags: "",
        internalVideoLink: "",
        reference: "",
        language: "English",
        actions: [{ name: "", step: "1", assignee: "unassigned" }],
        note: "",
        copyright: "",
        status: "active"
      },
      companies: [],
      errors: {},
      isSubmitting: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  async populateCompanies() {
    try {
      const { data: companies } = await getCompanys();
      this.setState({ companies });
    } catch (ex) {
      // Handle silently
    }
  }

  async populateERInstruction() {
    try {
      const erInstructionId = this.props.params?.id;

      if (erInstructionId === "new" || !erInstructionId) return;

      const { data: erInstruction } = await getERinstruction(erInstructionId);
      this.setState({ data: this.mapToViewModel(erInstruction) });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        this.props.navigate("/error");
    }
  }

  async componentDidMount() {
    const userProfile = auth.getProfile();
    if (userProfile?._id) {
      this.props.loadCurrentUser(userProfile._id);
    }

    await this.populateCompanies();
    await this.populateERInstruction();
  }

  schema = Joi.object({
    name: Joi.string().required(),
    category: Joi.string().optional().allow('', null),
    fieldType: Joi.string().optional().allow('', null),
    description: Joi.string().optional().allow('', null),
    serviceType: Joi.string().optional().allow('', null),
    copyright: Joi.string().optional().allow('', null),
    tags: Joi.string().optional().allow('', null),
    version: Joi.string().optional().allow('', null),
    internalVideoLink: Joi.string().optional().allow('', null),
    reference: Joi.string().optional().allow('', null),
    language: Joi.string().required(),
    actions: Joi.array().optional(),
    note: Joi.string().optional().allow('', null)
  });

  validate = () => {
    const { data } = this.state;
    const errors = {};

    if (!data.name || data.name.trim() === '') {
      errors.name = '"Name" is required';
    }

    if (!data.language || data.language.trim() === '') {
      errors.language = '"Language" is required';
    }

    return Object.keys(errors).length === 0 ? null : errors;
  };

  doSubmit = async () => {
    try {
      this.setState({ isSubmitting: true });

      // Clean actions
      const cleanActions = this.state.data.actions.map(action => ({
        name: action.name || '',
        step: action.step || '',
        assignee: action.assignee || 'unassigned'
      }));

      const userProfile = auth.getProfile();
      const isEditing = !!this.state.data._id;

      const submissionData = {
        user: userProfile._id,
        name: this.state.data.name || '',
        description: this.state.data.description || '',
        category: this.state.data.category || '',
        fieldType: this.state.data.fieldType || '',
        serviceType: this.state.data.serviceType || '',
        tags: this.state.data.tags || '',
        version: this.state.data.version || '',
        internalVideoLink: this.state.data.internalVideoLink || '',
        reference: this.state.data.reference || '',
        copyright: this.state.data.copyright || '',
        language: this.state.data.language || '',
        actions: cleanActions,
        note: this.state.data.note || '',
        status: 'active',
        createdOn: isEditing ? this.state.data.createdOn : new Date(),
        editedOn: new Date(),
      };

      if (isEditing && this.state.data.businessNo) {
        submissionData.businessNo = typeof this.state.data.businessNo === 'object'
          ? this.state.data.businessNo._id
          : this.state.data.businessNo;
      } else if (!isEditing) {
        const currentUser = this.props.currentUser;
        const isCompanyRole = (currentUser?.roleName === "Company") ||
          (currentUser?.role === "Company") ||
          (currentUser?.role?.name === "Company");

        if (currentUser && isCompanyRole && currentUser?.accountNo) {
          submissionData.businessNo = currentUser.accountNo;
        }
      }

      if (isEditing) {
        submissionData._id = this.state.data._id;
      }

      // Log the object sent to the backend
      console.log('Submitting ERInstruction to backend:', submissionData);
      const response = await saveERinstruction(submissionData);
      // Log the backend response
      console.log('Backend response for ERInstruction:', response);

      // Show success toast
      if (isEditing) {
        toast.success("ER instruction updated successfully!");
      } else {
        toast.success("ER instruction created successfully!");
      }

      this.props.navigate("/workinstructions/erinstructions/");
    } catch (ex) {
      this.setState({ isSubmitting: false });

      // Show error toast
      toast.error("Failed to save er instruction. Please try again.");

      if (ex.response) {
        const errors = {};
        if (ex.response.data && typeof ex.response.data === 'string') {
          const path = ex.response.data.split('"')[1];
          if (path) {
            errors[path] = ex.response.data;
          } else {
            errors.general = ex.response.data;
          }
        } else if (ex.response.data && ex.response.data.message) {
          errors.general = ex.response.data.message;
        } else {
          errors.general = 'An error occurred while saving the er instruction.';
        }
        this.setState({ errors });
      } else {
        this.setState({
          errors: {
            general: 'Network error. Please check your connection and try again.'
          }
        });
      }
    }
  };

  mapToViewModel(ERInstruction) {
    let actions = [];
    if (ERInstruction.actions && Array.isArray(ERInstruction.actions) && ERInstruction.actions.length > 0) {
      actions = ERInstruction.actions;
    } else {
      actions = [{ name: "", step: "1", assignee: "unassigned" }];
    }

    return {
      _id: ERInstruction._id,
      user: ERInstruction.user || auth.getProfile()._id,
      businessNo: ERInstruction.businessNo,
      category: ERInstruction.category || '',
      name: ERInstruction.name || '',
      description: ERInstruction.description || '',
      fieldType: ERInstruction.fieldType || '',
      serviceType: ERInstruction.serviceType || '',
      version: ERInstruction.version || '',
      tags: ERInstruction.tags || '',
      reference: ERInstruction.reference || '',
      internalVideoLink: ERInstruction.internalVideoLink || '',
      copyright: ERInstruction.copyright || '',
      actions: actions,
      language: ERInstruction.language || '',
      note: ERInstruction.note || '',
      status: ERInstruction.status || 'active',
      createdOn: ERInstruction.createdOn,
      editedOn: ERInstruction.editedOn
    };
  }

  addAction = () => {
    const nextStepNumber = (this.state.data.actions.length + 1).toString();
    const newAction = { name: "", step: nextStepNumber, assignee: "unassigned" };
    this.setState({
      data: {
        ...this.state.data,
        actions: [...this.state.data.actions, newAction]
      }
    });
  };

  removeAction = (index) => {
    const actions = [...this.state.data.actions];
    actions.splice(index, 1);

    const renumberedActions = actions.map((action, idx) => ({
      ...action,
      step: (idx + 1).toString()
    }));

    this.setState({
      data: {
        ...this.state.data,
        actions: renumberedActions
      }
    });
  };

  handleActionChange = (index, field, value) => {
    const actions = [...this.state.data.actions];
    actions[index][field] = value;
    this.setState({
      data: {
        ...this.state.data,
        actions: actions
      }
    });
  };

  render() {
    const { errors, data } = this.state;
    return (
      <React.Fragment>
        <div>
          <ol className="breadcrumb float-xl-right">
            <li className="breadcrumb-item">
              <Link to="/workinstructions/erinstructions/">ERInstructions</Link>
            </li>
            <li className="breadcrumb-item active">Add ER Instruction</li>
          </ol>
          <h1 className="page-header">
            Add ERInstruction
          </h1>

          <div className="row">
            <div className="col-xl-10">
              <Panel>
                <PanelHeader>Add ERInstruction</PanelHeader>
                <PanelBody className="panel-form">
                  <form className="form-horizontal form-bordered" onSubmit={this.handleSubmit}>
                    {errors.general && (
                      <div className="alert alert-danger mb-3">
                        {errors.general}
                      </div>
                    )}

                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">Language *</label>
                      <div className="col-lg-4">
                        <select
                          className="form-control"
                          name="language"
                          value={data.language}
                          onChange={this.handleChange}
                        >
                          <option value="">Select Language</option>
                          <option value="English">English</option>
                          <option value="普通话">普通话</option>
                          <option value="Español">Español</option>
                          <option value="日本語">日本語</option>
                          <option value="हिन्दी">हिन्दी</option>
                          <option value="Deutsch">Deutsch</option>
                          <option value="اَلْعَرَبِيَّةُ">اَلْعَرَبِيَّةُ</option>
                          <option value="Français">Français</option>
                          <option value="Italiano">Italiano</option>
                          <option value="한국어">한국어</option>
                          <option value="Tiếng Việt">Tiếng Việt</option>
                          <option value="русский язык">русский язык</option>
                          <option value="Português">Português</option>
                          <option value="Türkçe">Türkçe</option>
                          <option value="Nederlands">Nederlands</option>
                          <option value="Svenska">Svenska</option>
                          <option value="Limba română">Limba română</option>
                          <option value="Język polski">Język polski</option>
                          <option value="українська мова">українська мова</option>
                        </select>
                        {errors.language && (
                          <div className="alert alert-danger mt-1">{errors.language}</div>
                        )}
                      </div>
                      <label className="col-lg-2 col-form-label">Name *</label>
    z                  <div className="col-lg-4">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Name"
                          name="name"
                          value={data.name}
                          onChange={this.handleChange}
                        />
                        {errors.name && (
                          <div className="alert alert-danger mt-1">{errors.name}</div>
                        )}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">FieldType</label>
                      <div className="col-lg-4">
                        <select
                          className="form-control"
                          name="fieldType"
                          value={data.fieldType}
                          onChange={this.handleChange}
                        >
                          <option value="">Select Field Type</option>
                          <option value="Medical">Medical</option>
                          <option value="Safety">Safety</option>
                          <option value="Security">Security</option>
                          <option value="Rescue">Rescue</option>
                          <option value="Prevention">Prevention</option>
                          <option value="FireBrigade">Fire Brigade</option>
                          <option value="Police">Police</option>
                        </select>
                        {errors.fieldType && (
                          <div className="alert alert-danger mt-1">{errors.fieldType}</div>
                        )}
                      </div>

                      <label className="col-lg-2 col-form-label">Category</label>
                      <div className="col-lg-4">
                        {/* <select
                          className="form-control"
                          name="category"
                          value={data.category}
                          onChange={this.handleChange}
                        >
                          <option value="">Select Emergency Category</option>
                          <option value="heart-attack">Heart Attack</option>
                          <option value="fire">Fire Emergency</option>
                          <option value="cut">Cut/Wound</option>
                          <option value="accident">Accident</option>
                          <option value="earthquake">Earthquake</option>
                          <option value="flood">Flood</option>
                          <option value="poisoning">Poisoning</option>
                          <option value="drowning">Drowning</option>
                          <option value="burns">Burns</option>
                          <option value="stroke">Stroke</option>
                          <option value="choking">Choking</option>
                          <option value="bonefracture-openwound">bonefracture-openwound</option>
                          <option value="bonefracture">Bonefracture without bleeding</option>
                          <option value="skullfracture">Skullfracture</option>
                          <option value="spinalfracture">Spinalfracture</option>
                          <option value="bomb-threatening">bomb-threatening</option>
                          <option value="shock">Shock</option>
                          <option value="epilepstic assault">Epilepstic Assault</option>
                          <option value="diabetes assault">diabetes assault</option>
                          <option value="fainting">Fainting</option>
                          <option value="other">Other</option>
                        </select> */}
                        <Select
                          onChange={(selectedOption) => this.selectInputHandler("category", selectedOption)}
                          options={rootCauseTypes}
                          components={{
                            Option: OptionWithAvatar,
                            SingleValue: SingleValueWithAvatar,
                          }}
                          value={rootCauseTypes.find(option => option.value === data.category)}
                          className="w-100"
                          name="category"
                        />
                        {errors.category && (
                          <div className="alert alert-danger mt-1">{errors.category}</div>
                        )}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">ServiceType</label>
                      <div className="col-lg-4">
                        <Select
                          onChange={(selectedOption) => this.selectInputHandler("serviceType", selectedOption)}
                          options={serviceTypes}
                          components={{
                            Option: OptionWithAvatar,
                            SingleValue: SingleValueWithAvatar,
                          }}
                          value={serviceTypes.find(option => option.value === data.serviceType)}
                          className="w-100"
                          name="serviceType"
                        />
                        {errors.serviceType && (
                          <div className="alert alert-danger mt-1">{errors.serviceType}</div>
                        )}
                      </div>

                      <label className="col-lg-2 col-form-label">Version</label>
                      <div className="col-lg-4">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter version"
                          name="version"
                          value={data.version}
                          onChange={this.handleChange}
                        />
                        {errors.version && (
                          <div className="alert alert-danger mt-1">{errors.version}</div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">Description</label>
                      <div className="col-lg-10">
                        <textarea
                          className="form-control"
                          placeholder="Enter description"
                          name="description"
                          value={data.description}
                          onChange={this.handleChange}
                          rows="3"
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">Tags</label>
                      <div className="col-lg-10">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter tags"
                          name="tags"
                          value={data.tags}
                          onChange={this.handleChange}
                        />
                        {errors.tags && (
                          <div className="alert alert-danger mt-1">{errors.tags}</div>
                        )}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">VideoLink</label>
                      <div className="col-lg-10">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter VideoLink"
                          name="internalVideoLink"
                          value={data.internalVideoLink}
                          onChange={this.handleChange}
                        />
                        {errors.internalVideoLink && (
                          <div className="alert alert-danger mt-1">{errors.internalVideoLink}</div>
                        )}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">Reference</label>
                      <div className="col-lg-10">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter Reference"
                          name="reference"
                          value={data.reference}
                          onChange={this.handleChange}
                        />
                        {errors.reference && (
                          <div className="alert alert-danger mt-1">{errors.reference}</div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">Copyrights</label>
                      <div className="col-lg-10">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="copyrights by...."
                          name="copyright"
                          value={data.copyright}
                          onChange={this.handleChange}
                        />
                        {errors.copyright && (
                          <div className="alert alert-danger mt-1">{errors.copyright}</div>
                        )}
                      </div>
                    </div>
                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">Actions</label>
                      <div className="col-lg-10">
                        <button
                          type="button"
                          className="btn btn-success btn-sm mb-3"
                          onClick={this.addAction}
                        >
                          Add Action
                        </button>
                        {this.state.data.actions.map((action, index) => (
                          <div key={index} className="card mb-3">
                            <div className="card-body">
                              <div className="form-group row">
                                <div className="col-lg-7">
                                  <label className="form-label">Action</label>
                                  <Editor
                                    initialContent={action.name}
                                    onChangeHandler={(value) => this.handleActionChange(index, 'name', value)}
                                  />
                                </div>
                                <div className="col-lg-2">
                                  <label className="form-label">Assignee</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter assignee"
                                    value={action.assignee || ''}
                                    onChange={(e) => this.handleActionChange(index, 'assignee', e.target.value)}
                                  />
                                </div>
                                <div className="col-lg-1">
                                  <label className="form-label">Step</label>
                                  <input
                                    type="text"
                                    className="form-control text-center"
                                    placeholder="1"
                                    value={action.step}
                                    onChange={(e) => this.handleActionChange(index, 'step', e.target.value)}
                                    maxLength="1"
                                    style={{ fontSize: '14px', fontWeight: 'bold' }}
                                  />
                                </div>
                                <div className="col-lg-2">
                                  <label className="form-label">&nbsp;</label>
                                  <div>
                                    <button
                                      type="button"
                                      className="btn btn-danger btn-sm"
                                      onClick={() => this.removeAction(index)}
                                    >
                                      <IoMdTrash />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    <div className="form-group row">
                      <label className="col-lg-2 col-form-label">Note</label>
                      <div className="col-lg-10">
                        <textarea
                          className="form-control"
                          placeholder="Enter additional notes"
                          name="note"
                          value={data.note}
                          onChange={this.handleChange}
                          rows="3"
                        />
                        {errors.note && (
                          <div className="alert alert-danger mt-1">{errors.note}</div>
                        )}
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-lg-12">
                        <button
                          type="submit"
                          disabled={this.state.isSubmitting}
                          className="btn btn-primary"
                        >
                          {this.state.isSubmitting ? 'Submitting...' : 'Submit'}
                        </button>
                      </div>
                    </div>
                  </form>
                </PanelBody>
              </Panel>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: getCurrentUser(state)
});

const mapDispatchToProps = (dispatch) => ({
  loadCurrentUser: (id) => dispatch(loadCurrentUser(id))
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ERInstruction));










